export const inverse = {
  left: 'right',
  right: 'left',
  top: 'bottom',
  bottom: 'top'
};
